import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  borderRadius: '5px',

  colors: {
    primary: '#30826A',
    primaryBright: '#54CBAF',
    secondary: '#FF9900',
    secondaryBright: '#FFD5A1',
    text: '#323232',
    grey: '#EFF1F4',
    greyDark: '#E0E0E0',
    error: '#D50000',
  },

  fonts: {
    copy: {
      size: '14px',
    },
    h1: {
      size: '24px',
    },
    label: {
      size: '11px',
    },
  },
};

export { theme };
